module.exports = __webpack_public_path__ + "img/support_enable.56904d44.svg";